<template>
  <td
    v-if="!orderDayIsValid && getStockByDay && getStockByDay.orderId"
    class="group border-l border-gray-300 align-center"
    :class="{
      'bg-green-50': getStockByDay.submitted,
      'bg-red-50': !getStockByDay.submitted
    }">
    <div v-if="getStockedProduct">
      <span class="font-semibold text-lg">{{ getStockedProduct.originalQuantity }}</span> Stück
    </div>
    <span v-else class="text-xs text-gray-500 opacity-0 group-hover:opacity-100">
      nicht mehr<br>änderbar
    </span>
  </td>
  <td v-else-if="!orderDayIsValid" class="group border-l border-gray-300 align-center bg-black/5">
    <span class="text-xs text-gray-500 opacity-0 group-hover:opacity-100">
      Bestellvorlauf abgelaufen
    </span>
  </td>
  <td v-else-if="!productIsOrderable" class="group border-l border-gray-300 align-center bg-black/5">
    <span v-if="item.orderable_from" class="text-xs text-gray-500 opacity-0 group-hover:opacity-100">
      bald verfügbar
    </span>
    <span v-else class="text-xs text-gray-500 opacity-0 group-hover:opacity-100">
      nicht verfügbar
    </span>
  </td>
  <!-- <td
    v-else-if="!hover"
    class="group border-l border-gray-300 align-center pt-4">
    <div >
      <span class="font-semibold text-lg">{{ getStockedProduct?.originalQuantity ?? 0 }}</span> Stück
    </div>
  </td> -->
  <td
    v-else
    class="border-l border-gray-300 hover:bg-white"
    :class="{'align-top': hover, 'align-center': !hover}"
    @mouseover="hover = true"
    @mouseleave="hover = false">
    <div v-show="!hover">
      <span class="font-semibold text-lg">{{ getStockedProduct?.newQuantity ?? 0 }}</span> Stück
    </div>
    <ProductQuantityField
      v-show="hover"
      :value="getStockedProduct ? getStockedProduct.newQuantity : undefined"
      :original="getStockedProduct ? getStockedProduct.originalQuantity : undefined"
      :hovering="hover"
      :item="item"
      :date="date"
      @update="onChangeQuantity" />
    <modal
      v-if="showUnusualQuantityModal"
      :show="showUnusualQuantityModal"
      :closeable="true"
      @close="() => showUnusualQuantityModal = false">
      <div class="p-4">
        <h3
          class="text-xl font-bold mb-4">
          Unübliche Stückzahl
        </h3>
        <p>Die gewählte Stückzahl sieht unüblich aus. Soll diese beibehalten werden?</p>
        <div class="flex mt-4">
          <button
            class="mr-2 ml-auto text-black bg-white px-4 py-2 text-sm flex mt-2 transition-opacity border border-black hover:opacity-50"
            @click.prevent="() => {
              this.showUnusualQuantityModal = false
              this.quantity = null
              this.hover = true
            }">
            Stückzahl überarbeiten
          </button>
          <button
            class="button-primary"
            @click.prevent="() => {
              this.submitQuantityToOrder()
              this.showUnusualQuantityModal = false
            }">
            Ja, Stückzahl beibehalten
          </button>
        </div>
      </div>
    </modal>
  </td>
</template>

<script>
import format from 'date-fns/format'
import isSameDay from 'date-fns/isSameDay'

import Modal from '@/Jetstream/Modal'
import numberRedundancyCheck from '@/Components/Product/numberRedundancyCheck'
import ordersStockStore from '@/Store/ordersStock'

import AvailabilityMixin from '../AvailabilityMixin'
import ProductQuantityField from './ProductQuantityField'

const stockState = ordersStockStore.state

export default {
  name: 'ProductQuantityCell',
  components: { ProductQuantityField, Modal },
  mixins: [ AvailabilityMixin ],
  props: {
    item: {
      type: Object,
      required: true
    },
    date: {
      type: Date,
      required: true
    }
  },

  data: () => ({
    stockState,
    quantity: null,
    hover: false,
    showUnusualQuantityModal: false,
  }),

  computed: {
    productIsOrderable() {
      return this.item.orderable_days_in_calender_week.includes(
        format(this.date, 'yyyy-MM-dd')
      ) && !ordersStockStore.isExcluded(this.date)
    },

    getStockByDay() {
      return this.stockState.stock.find(item => isSameDay(item.orderDate, this.date))
    },

    getStockedProduct() {
      const product = this.getStockByDay ? this.getStockByDay.products.find(({ item }) => item && item.id === this.item.id) : null

      return product ? product : null
    }
  },

  methods: {
    onChangeQuantity(quantity) {
      const atypicalQuantity = this.item.primary_category ? this.item.primary_category.atypical_quantity : null
      this.quantity = quantity

      if (
          (atypicalQuantity !== null && quantity > atypicalQuantity)
        || numberRedundancyCheck(quantity))
      {
        this.showUnusualQuantityModal = true
      } else {
        this.submitQuantityToOrder()
      }
    },

    submitQuantityToOrder () {
      ordersStockStore.updateStock({
        orderDate: this.date,
        product: this.item,
        quantity: this.quantity,
      })
    }
  }
}
</script>
